import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { connect } from "react-redux";
import { osVersion, osName, isMobile } from 'react-device-detect';
import Dashboard from '../components/Menu/Dashboard';
import { addBeneficiary, getBeneficiaries, getBeneficiaryCore, getBeneficiaryCoreAccount, deleteBeneficiary, updateBeneficiary } from "../actions/beneficiary";
import { transferRequest } from "../actions/transfers";
import { getBalanceUser } from "../actions/balances";
import { createCodeRecovery } from "../actions/codes";
import { getInstitutionCore } from "../actions/institutionsCore";
import { internalTransferRequest, externalTransferRequest, ownTransferRequest } from "../actions/transferscore";
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import Transfers from '../components/Transfers/Transfers';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import BeneficiaryList from '../components/Complements/BeneficiaryList';
import TransferForm from '../components/Transfers/TransferForm';
import VoucherTransfersWeb from '../components/Transfers/VoucherTransfersWeb';
import DialogOTP from '../components/Complements/DialogOTP';
import BeneficiaryFormDialog from '../components/Complements/DefaultUserForm';
import { codeActivity, changeStatusUser } from '../actions/codes'
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import { List, ListItem, ListItemAvatar, Avatar, ListItemText, Grid, Button, DialogContentText, CircularProgress, Paper } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import BeneficiaryInternalForm from '../components/Complements/BeneficiaryInternalForm';
import BeneficiaryExternalForm from '../components/Complements/BeneficiaryExternalForm';
import StandardDialog from '../components/Complements/StandardDialog';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { urlVoucher } from '../services/urls';
import AddIcon from '@material-ui/icons/Add';
import MessageInfo from '../components/Complements/MessageInfo';
import { sendLogs } from '../functions/function-logs';
import { validateIp } from '../functions/store';
import { encrypt, sendMobile, decrypt } from '../functions/mobile';
import { feathersCreateData } from '../services';
import DialogConfirm from '../components/Complements/DialogConfirm'
import BeneficiaryOwnFormEdit from '../components/Complements/BeneficiaryOwnFormEdit';
import Footer from '../components/Complements/Footer';
import { store } from '../store';

class TransfersExternalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialogBeneficiaryList: false,
            openBeneficiaryForm: false,
            dataSendTransfers: {},
            beneficiaries: [],
            beneficiarySelected: {},
            dataPayment: {
                cedule: '',
                name: '',
                email: '',
                entity: '',
                number: ''
            },
            beneficiaryFormData: {
                number: '',
                cedule: '',
                name: '',
                email: '',
                entity: '',
                document: 'Cédula',
                institution: '',
                beneficiary: 'INTERNO',
                type: '',
                Customers: {},
                accounts: []
            },
            beneficiaryFormDataExternal: {
                number: '',
                cedule: '',
                name: '',
                email: '',
                entity: '',
                document: '1',
                institution: '',
                cellphone: '',
                beneficiary: 'INTERNO',
                type: {},
                Customers: {},
                accounts: []
            },
            transfersData: {},
            beneficiaryDataSend: {},
            openDialogOTP: false,
            QRPay: '',
            codeType: 0,
            initialTime: Date.now(),
            process: 'TRANSFERS',
            otp: '',
            numberAccount: {},
            otpId: '',
            accounts: [],
            accountSelected: {},
            institutions: [],
            ownBeneficiary: {
                open: false,
                data: {}
            },
            internalBeneficiary: {
                open: false,
                data: {}
            },
            externalBeneficiary: {
                open: false,
                data: {}
            },
            confirmDialog: {
                open: false,
                title: ''
            },
            loadingOTP: false,
            loading: false,
            isviewvoucher: false,
            responseservertransfer: {},
            numberdocumento: '',
            contAttemptsInternalTransfer: 0,
            contAttemptsExternalTransfer: 0,
            contAttemptsCreateBeneficiary: 0,
            contAttemptsCreateExternalBeneficiary: 0,
            contAttemptsDeleteBeneficiary: 0,
            opendialoglistaccount: false,
            sendTransaction: false,
            openAccordionInternal: true,
            openAccordionExternal: true,
            openDialogConfirmation: false,
            permissions: store.getState().permissions
        };
        // this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        // console.log(store.getState());
        // console.log('didmount transfers', this.props.auth)

        this.filterAccounts(true)
        this.props.getBeneficiaries(this.props.auth.vusk).then(r => {
            //console.log('los beneficiarios ', r.payload)
            if (r.payload) {
                if (r.payload.length > 0) {
                    this.setState({ beneficiaries: r.payload })
                } else {
                    this.props.handleOpenSnack('No existen Beneficiarios.', 'info')
                }
            }
        })
        //const transfersCoreService = client.service('transfers-core');
        /*         transfersCoreService.on('created', transfer => {
                    // console.log(transfer)
                    const { cedule } = transfer
                    const { NumeroCliente, Identificacion } = this.props.user
                    if (cedule === Identificacion) {
                         // console.log('nueva transferencia', transfer)
                        this.props.getBalanceUser({NumeroCliente, SecuencialEmpresa: 1}).then( res => {
                            this.filterAccounts(false)
                        })
                        .catch(err=> {
                            //console.log(' error al obtener balances ', err)
                        })
                    }
                }
                ); */
        // carga balances
        const { numeroCliente } = this.props.user
        // console.log(this.props.user)
        // console.log(numeroCliente)
        this.props.getBalanceUser({ NumeroCliente: numeroCliente, SecuencialEmpresa: 1 }).then(res => {
            this.filterAccounts(false)
        })
            .catch(err => {
                //console.log(' error al obtener balances ', err)
            })

        this.setState({ isviewvoucher: false })
    }

    handleChangeOpenAccordionInternal = () => {

        const { openAccordionInternal } = this.state

        this.setState({
            openAccordionInternal: !openAccordionInternal
        })
    }

    handleChangeOpenAccordionExternal = () => {

        const { openAccordionExternal } = this.state

        this.setState({
            openAccordionExternal: !openAccordionExternal
        })
    }

    handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(this.props.parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        const tokenLength = parseInt(tokenLengthObj[0].value)
        if (valueinput.toString().length === tokenLength) {
            this.handleOTPSubmit({ data: valueinput.toString() });
        }

    }

    handleAccountChange = () => {
        const { opendialoglistaccount } = this.state;

        this.setState({
            opendialoglistaccount: !opendialoglistaccount
        })
    }
    // funciones
    getAccountTypeName = (cod) => {
        // console.log(cod)
        const { tipoCuentaTransferencias } = this.props.entities
        // console.log(this.props.entities)
        const accName = tipoCuentaTransferencias.find(acc => {
            // console.log(acc.codigo)
            if (acc.codigo === cod) {
                return true
            } else {
                return false
            }
        })
        if (accName !== undefined) {
            return accName.nombre
        } else {
            return 'Nro. Cuenta'
        }
    }

    handleChangeStatusUser = () => {
        this.setState({
            loading: true
        })

        this.props.changeStatusUser({ emited: "NAVCHANGESTATUS", iduser: this.props.auth.id }).then(
            response => {
                this.setState({
                    loading: false
                })
            }
        ).catch(
            error => {
                this.setState({
                    loading: false
                })
            }
        )
    }

    handleValidateAttemptsOtp = (cont, typeproccess) => {

        const { parameters, auth, devices, getDeviceData } = this.props

        // console.log("Parametros: ", parameters)getDeviceData = {getDeviceData}

        let contAttemptsAllowed = (parameters.length > 0) ? filterArrayEqual(parameters, 'code', 'OTP_TRY')[0].value : 5

        cont++;

        switch (typeproccess) {
            case 'INTERNAL_TRANSFER':
                sendLogs(auth.vusk, {
                    NumeroCuentaOrigen: this.state.accountSelected.Codigo,
                    NumeroCuentaDestino: this.state.beneficiarySelected.number,
                    Valor: this.state.transfersData.amount,
                    Detalle: this.state.transfersData.concept,
                    MontoDiario: 10000,
                    montoMensual: 40000,
                    otpId: this.state.otpId,
                    email: this.state.transfersData.email
                }, 9, devices, getDeviceData)
                this.setState({ contAttemptsInternalTransfer: cont })
                break;
            case 'EXTERNAL_TRANSFER':
                sendLogs(auth.vusk, {
                    NumeroCuentaOrigen: this.state.accountSelected.Codigo,
                    Valor: this.state.transfersData.amount,
                    TipoIdentificacion: this.state.beneficiarySelected.document,
                    Identificacion: this.state.beneficiarySelected.cedule,
                    NombreApellido: this.state.beneficiarySelected.name,
                    CodigoTipoInstitucion: this.state.beneficiarySelected.entity,
                    CodigoTipoCuenta: this.state.beneficiarySelected.type,
                    NumeroCuentaDestino: this.state.beneficiarySelected.number,
                    SecuencialInstitucion: this.state.beneficiarySelected.institution,
                    Detalle: this.state.transfersData.concept,
                    MontoDiario: 10000,
                    montoMensual: 40000,
                    otpId: this.state.otpId,
                    email: this.state.transfersData.email
                }, 18, devices, getDeviceData)
                this.setState({ contAttemptsExternalTransfer: cont })
                break;
            case 'CREATE_BENEFICIARY':
                sendLogs(auth.vusk, {
                    type: "CREATE BENEFICIARY INTERNAL",
                    data: this.state.beneficiaryDataSend
                }, 14, devices, getDeviceData)
                this.setState({ contAttemptsCreateBeneficiary: cont })
                break;
            case 'CREATE_EXTERNAL_BENEFICIARY':
                sendLogs(auth.vusk, {
                    type: "CREATE BENEFICIARY EXTERNAL",
                    data: this.state.beneficiaryDataSend
                }, 14, devices, getDeviceData)
                this.setState({ contAttemptsCreateExternalBeneficiary: cont })
                break;
            case 'DELETE_BENEFICIARY':
                this.setState({ contAttemptsDeleteBeneficiary: cont })
                break;
            default:
                break;
        }

        if (cont > contAttemptsAllowed) {
            this.setState({ openDialogOTP: false });
            this.handleChangeStatusUser()
            this.props.handleOpenSnack('Se ha excedido el número de intentos permitidos. Por favor contáctese con COOPERATIVA GAÑANSOL llamando al XXXXXXXX.', 'error');
        }

    }

    filterAccounts = (did) => {
        const { balances } = this.props
        const { accountSelected } = this.state
        // console.log('balances en trasfercontainer ', balances)
        const filterBalance = balances.filter(data => {
            if (data.PRODUCTALIAS === 'AHORROS A LA VISTA') {
                return true
            } else {
                return false
            }
        })
        if (filterBalance.length > 0) {
            if (did) {
                this.setState({ accounts: filterBalance, accountSelected: filterBalance[0] })
            } else {
                let as = filterBalance.find(val => {
                    if (val.PRODUCTBANKID === accountSelected.PRODUCTBANKID) {
                        return true
                    } else {
                        return false
                    }
                })
                // console.log('actualizamos el saldo a ', as)
                this.setState({ accounts: filterBalance, accountSelected: as })
            }

        }
        // console.log('filtrado ', filterBalance, balances)
    }
    clearForm = () => {
        this.setState(
            {
                beneficiaryFormData: {
                    number: '',
                    cedule: '',
                    name: '',
                    email: '',
                    entity: '',
                    document: 'Cédula',
                    institution: '',
                    beneficiary: 'INTERNO',
                    type: '',
                    Customers: {},
                    accounts: []
                }
            }
        )
    }
    onAcceptClick = async (values) => {

        try {
            // console.log('values: ', values)
            this.setState({
                loading: true
            })
            const { auth, devices } = this.props
            const { beneficiaryFormDataExternal, beneficiaries } = this.state
            // console.log('AUTH', auth)
            // console.log('devices', devices)
            if ((beneficiaryFormDataExternal.type.codigo) && (values.institution)) {

                const dataResult = beneficiaries.filter((beneficiary) => {
                    // console.log('BENEFICIARY: ', beneficiary)
                    if ((beneficiary.number === values.number) && (beneficiary.beneficiary === "EXTERNO")) {
                        return true
                    } else {
                        return false
                    }
                })
                //console.log('dataSend', beneficiaryFormDataExternal)

                //console.log('values', values)

                if (dataResult.length === 0) {

                    /* this.setState({
                        beneficiaryDataSend: {
                                                owner:auth.vusk,
                                                type: beneficiaryFormDataExternal.type.codigo,
                                                type_name: beneficiaryFormDataExternal.type.nombre,
                                                entity: "NA",
                                                institution: values.institution.secuencial,
                                                document: values.document,
                                                cedule: values.cedule,
                                                name: values.name.toUpperCase(),
                                                number: values.number,
                                                email: values.email.toLowerCase(),
                                                beneficiary: 'EXTERNO',
                                                name_institution: values.institution.nombre,
                                                cellphone : values.cellphone
                                            },
                    process : "ADD_BENEFICIARY"
                }) */

                    const { ip, device, mac } = devices

                    /*let sendData = encrypt(JSON.stringify({
                        emited: 'NAVCREATECODE',
                        type : 14,
                        deviceData: device,
                        ip,
                        mac
                    } ))

                    await feathersCreateData('codes-recovery', { sendData })()

                    this.setState({
                        initialTime: Date.now(),
                        openDialogOTP: true,
                        loading : false
                    }) */

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action: "ADD_BENEFICIARY",
                        dataUsersDefault: {
                            user: auth.identification,
                            type: beneficiaryFormDataExternal.type.codigo,
                            type_name: beneficiaryFormDataExternal.type.name,
                            entity: "NA",
                            institution: values.institution.spi_code,
                            document: values.document,
                            cedule: values.cedule,
                            name: values.name.toUpperCase(),
                            number: values.number,
                            email: values.email,
                            beneficiary: 'EXTERNO',
                            name_institution: values.institution.institution_name,
                            cellphone: values.cellphone,
                            alias: values.name.toUpperCase()
                        },
                        dataDevice: {
                            ip,
                            mac,
                            device,
                        },
                        type: 14,
                        otp: ""
                    }))
                    //console.log('add 1')
                    //console.log(sendDataAddBeneficiary)
                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

                    if (responseCreateBeneficiary.error === false) {
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({ openBeneficiaryForm: false, loading: false })
                        this.clearForm()
                        //this.handleCloseDialogOTP()
                        // console.log('beneficiarySelected')
                        this.setState({
                            beneficiarySelected: {
                                user: auth.identification,
                                type: beneficiaryFormDataExternal.type.codigo,
                                type_name: beneficiaryFormDataExternal.type.name,
                                entity: "NA",
                                institution: values.institution.spi_code,
                                document: values.document,
                                cedule: values.cedule,
                                name: values.name.toUpperCase(),
                                number: values.number,
                                email: values.email,
                                beneficiary: 'EXTERNO',
                                name_institution: values.institution.institution_name,
                                cellphone: values.cellphone,
                                accname: beneficiaryFormDataExternal.type.name,
                                id: responseCreateBeneficiary.data
                            }
                        })
                    } else {
                        this.setState({ loading: false })
                        //this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else {
                    this.setState({ loading: false })
                    this.props.handleOpenSnack('El beneficiario ya existe. Por favor verifique los datos.', 'info');
                }

            } else {

                this.setState({ loading: false })
                this.props.handleOpenSnack('Debe seleccionar una institución y un tipo de cuenta.', 'info');
            }

        } catch (error) {
            this.setState({ loading: false })
            this.props.handleOpenSnack('Ha ocurrido un error. Por favor vuelva a intentar.', 'info');
        }

        // this.props.addBeneficiary()
    }
    handleGetSelectAccount = (value) => {
        this.setState({ numberAccount: value })
    }
    handleAddBeneficiaryCore = async () => {

        try {

            this.setState({ loading: true })

            const { auth, devices } = this.props
            const { beneficiaryFormData, numberAccount, beneficiaries } = this.state
            //console.log('anadiendoooo', numberAccount)
            const { name, email, cedule, document } = beneficiaryFormData

            const dataResult = beneficiaries.filter((beneficiary) => {

                if ((beneficiary.number === numberAccount.PRODUCTBANKID) && (beneficiary.beneficiary === "INTERNO")) {
                    return true
                } else {
                    return false
                }
            })

            if (dataResult.length === 0) {

                const { ip, device, mac } = devices

                const sendDataAddBeneficiary = encrypt(JSON.stringify({
                    action: "ADD_BENEFICIARY",
                    dataUsersDefault: {
                        owner: auth.identification,
                        type: 'AHORROS',
                        type_name: numberAccount.tipoCuentaNombre,
                        entity: 'LOCAL',
                        institution: 'COOPERATIVA GAÑANSOL',
                        document: document,
                        cedule,
                        name,
                        number: numberAccount.PRODUCTBANKID,
                        email,
                        beneficiary: 'INTERNO',
                        name_institution: "COOPERATIVA GAÑANSOL",
                        cellphone: "",
                        alias: "NA"
                    },
                    dataDevice: {
                        ip,
                        mac,
                        device,
                    },
                    type: 14,
                    otp: ""
                }))
                // console.log('add 2')

                const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

                if (responseCreateBeneficiary.error === false) {
                    this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                    this.setState({ openBeneficiaryForm: false, loading: false })
                    this.clearForm()
                    //this.handleCloseDialogOTP()
                    this.setState({
                        beneficiarySelected: {
                            user: auth.identification,
                            type: 'AHORROS',
                            type_name: numberAccount.PRODUCTALIAS,
                            entity: 'LOCAL',
                            institution: 'COOPERATIVA GAÑANSOL',
                            document: 'Cédula',
                            cedule,
                            name,
                            number: numberAccount.PRODUCTBANKID,
                            email,
                            beneficiary: 'INTERNO',
                            name_institution: "COOPERATIVA GAÑANSOL",
                            cellphone: "", accname: 'AHORROS',
                            id: responseCreateBeneficiary.data,
                            alias: "NA"
                        }
                    })
                } else {
                    this.setState({ loading: false })
                    //this.handleCloseDialogOTP()
                    this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                }

                /* const { ip, device, mac } = devices

                let sendData = encrypt(JSON.stringify({
                    emited: 'NAVCREATECODE',
                    type : 14,
                    deviceData: device,
                    ip,
                    mac
                } ))

                await feathersCreateData('codes-recovery', { sendData })()

                this.setState({
                    initialTime: Date.now(),
                    openDialogOTP: true,
                    loading : false
                }) */

            } else {

                this.setState({ loading: false })
                this.props.handleOpenSnack('El beneficiario ya se encuentra agregado.', 'info')
            }


        } catch (error) {

            this.setState({ loading: false })
            this.props.handleOpenSnack('Ha ocurrido un error al generar el código', 'error')
        }


    }

    // handle
    handleOpenBeneficiaryList = () => {
        this.props.getBeneficiaries(this.props.auth.vusk).then(r => {
            // console.log('los beneficiarios ', r.payload)
            if (r.payload) {
                this.setState({ beneficiaries: r.payload, openDialogBeneficiaryList: true, openAccordionInternal: true, openAccordionExternal: true })
            }
        })

        // console.log('la verdad lista ', this.state.openDialogBeneficiaryList)
    }
    handleGetBeneficiarySelected = (beneficiarySelected) => {
        // se obtiene el nombre del tipo de cuenta
        // console.log("Cuenta seleccionada: ", this.state.accountSelected)
        // console.log("Beneficiario seleccionado: ", beneficiarySelected)

        if (this.state.accountSelected.codigo !== beneficiarySelected.number) {

            let BS = beneficiarySelected
            if ((beneficiarySelected.beneficiary === 'EXTERNO')) {
                // console.log('el beneficiario ', beneficiarySelected)
                let complete = true
                /* for (const key in beneficiarySelected) {
                    if (beneficiarySelected[key] === "") {
                        if (key === 'document') {
                            beneficiarySelected[key] = '1'
                        }
                        complete = false
                    }
                } */
                if (complete) {
                    // verifica que esten todos los datos
                    // console.log('porque entra aqui')
                    const accname = this.getAccountTypeName(beneficiarySelected.type)
                    BS.accname = accname

                } else {
                    this.props.handleOpenSnack('Debe completar la información del beneficiario.', 'info')
                    //this.handleChangeEntity({codigo: beneficiarySelected.entity})
                    this.setState({ externalBeneficiary: { ...this.state.externalBeneficiary, open: true, data: beneficiarySelected } })
                }
            } else {
                BS.accname = beneficiarySelected.type
            }

            this.setState({ beneficiarySelected: BS, openDialogBeneficiaryList: false })
        } else {
            this.props.handleOpenSnack('No se permite seleccionar un número de cuenta idéntico al número de cuenta origen. Por favor seleccione otro beneficiario.', 'info')
        }
        // console.log('se a seleccionado ', beneficiarySelected)
    };
    handleCloseBeneficiaryList = () => {
        this.setState({ openDialogBeneficiaryList: false });
    };
    handleSubmit = (values) => {
        try {

            const { parameters } = this.props;

            const resultFilterValueMinBalance = parameters.filter((param) => param.code === "MINIMUM_BALANCE")
            const valueMinBalance = (resultFilterValueMinBalance.length > 0) ? resultFilterValueMinBalance[0].value : "2"
            //console.log(resultFilterValueMinBalance)
            const { daily, monthly, mAmount, dAmount, updateQuota } = this.props.quotas[0]
            let sameDay = moment(moment(new Date(updateQuota)).format('YYYY-MM-DD')).isSame(moment(new Date()).format('YYYY-MM-DD'))
            let sameMonth = moment(moment(new Date(updateQuota)).format('YYYY-MM-DD')).isSame(moment(new Date()).format('YYYY-MM-DD'), 'month')
            //console.log('', sameDay,  sameMonth,
            //(parseFloat(dAmount) + parseFloat(values.amount)), parseFloat(daily), (parseFloat(dAmount) + parseFloat(values.amount)) >=  parseFloat(daily))
            // si la fecha esta actualizada
            // if(state) {
            //console.log(this.props.quotas, parseFloat(values.amount) , parseFloat(daily) , parseFloat(values.amount) >= parseFloat(daily) , parseFloat(values.amount)>= parseFloat(monthly))
            if (parseFloat(values.amount) > this.state.accountSelected.SALDOINT) {
                this.props.handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
            } else if ((parseFloat(dAmount) >= parseFloat(daily) ||
                (parseFloat(dAmount) + parseFloat(values.amount)) > parseFloat(daily)) && sameDay
            ) {
                this.props.handleOpenSnack('El monto excede el límite de transferencia diaria', 'error')
            } else if ((parseFloat(mAmount) >= parseFloat(monthly) ||
                (parseFloat(mAmount) + parseFloat(values.amount)) > parseFloat(monthly)) && sameMonth
            ) {
                this.props.handleOpenSnack('El monto excede el límite de transferencia mensual', 'error')
            } else if (parseFloat(values.amount) > parseFloat(daily)) {
                this.props.handleOpenSnack('El valor excede el monto diario permitido', 'error')
            } else if (parseFloat(values.amount) > parseFloat(monthly)) {
                this.props.handleOpenSnack('El valor excede el monto mensual permitido', 'error')
            } else if ((parseFloat(this.state.accountSelected.SALDOINT) - parseFloat(values.amount)) < parseFloat(valueMinBalance)) {
                this.props.handleOpenSnack('El valor del saldo mínimo no debe ser menor a $ ' + valueMinBalance, 'error')
            } else {
                this.handleProcessTransfer(values)
            }

        } catch (error) {
            this.setState({ loading: false })
            //console.log('error al crear otp ', error)
        }

    }

    handleProcessTransfer = async (values) => {
        try {
            this.setState({ loading: true })
            await this.props.getQuotas({ cedule: this.props.auth.vusk })
            const { getDeviceData, updateIpDevice, devices } = this.props
            const { ip } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            if (!isEmpty(this.props.devices)) {
                const { device, ip: ipdevice, mac } = this.props.devices
                values.device = `${device}`;
                values.ip = ipdevice;
                values.mac = mac;
            } else {
                values.ip = ipSend;
                values.device = `${osName} ${osVersion}`;
                values.mac = 'NAVEGADOR';
            }
            values.concept = values.concept.toUpperCase()
            const { beneficiarySelected } = this.state


            let sendData = encrypt(JSON.stringify({
                values,
                beneficiarySelected,
                NumeroCuentaOrigen: encrypt(this.state.accountSelected.PRODUCTBANKID),
                type: (beneficiarySelected.beneficiary === 'INTERNO') ? 9 : (beneficiarySelected.beneficiary === 'EXTERNO') ? 18 : 34
            }))

            this.props.transferRequest({ sendData }).then(r => {
                //console.log('mi respuesta es ', r.payload)

                const { responseData } = r.payload

                const responseDataDecrypt = JSON.parse(decrypt(responseData ? responseData : r.payload))
                console.log(responseDataDecrypt);
                if (responseDataDecrypt.type === "success") {

                    this.setState({
                        initialTime: Date.now(),
                        codeType: 0,
                        openDialogOTP: true,
                        process: (beneficiarySelected.beneficiary === 'INTERNO') ? 'INTERNAL_TRANSFER' : (beneficiarySelected.beneficiary === 'EXTERNO') ? 'EXTERNAL_TRANSFER' : 'OWN_TRANSFER',
                        transfersData: values
                    })

                } else {

                    this.props.handleOpenSnack(responseDataDecrypt.alert  || responseDataDecrypt.message, responseDataDecrypt.type  || 'error')

                }

                this.setState({ loading: false })
            }).catch(err => {
                console.log(err)
                this.setState({ loading: false })
                this.props.handleOpenSnack('Ha ocurrido un error. Por favor vuelva a intentar.', 'error')
            })
        } catch (error) {
            //console.log(error)
        }
    }

    handleAceptDialog = (values) => {
        try {
            this.handleCloseBeneficiaryList()
            const { id } = values.data
            this.props.deleteBeneficiary(id).then(res => {
                this.props.handleOpenSnack('Se ha eliminado el beneficiario correctamente.', 'success')
                this.setState({ confirmDialog: { open: false, title: '' } })
                this.setState({
                    externalBeneficiary: {
                        ...this.state.externalBeneficiary,
                        open: false
                    }
                })
                this.handleCloseDialogOTP()
                this.setState({ openBeneficiaryForm: false, })
                this.clearForm()
                this.setState({ loading: false })
            }).catch(err => {
                this.setState({ loading: false })
                this.handleCloseDialogOTP()
                //console.log('error al eliminar beneficiario ', err)
            })
        } catch (error) {
            //console.log(error)
        }
    }

    handleUpdatedBalances = async () => {

        await this.props.getBalanceUser({ NumeroCliente: this.props.user.numeroCliente, SecuencialEmpresa: 1, EstaActiva: true }).then(res => {
            //console.log(res)
            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => item.PRODUCTBANKID === this.state.accountSelected.PRODUCTBANKID)
            this.setState({
                accountSelected: getdataaccountselected[0]
            })

        })
            .catch(err => {
            })
    }

  valueofidentification = (identification) => {
  switch (identification.length) {
    case 13:
      return "1"
    case 10:
      return "3"
    default:
      return "10"
  }
}


    handleOTPSubmit = async (values) => {

        try {

            const { beneficiarySelected,
                process,
                transfersData,
                accountSelected,
                sendTransaction,
                beneficiaryDataSend
            } = this.state
            const { concept, amount } = transfersData
            const { number, cedule, name, entity, type, document, institution, user, email, name_institution } = beneficiarySelected
            const { devices } = this.props
            //console.log(devices)
            const { ip, mac, device } = devices

            this.setState({ loading: true })
            this.handleCloseDialogOTP()

            let typeCodeOtp = 9;

            switch (process) {
                case "INTERNAL_TRANSFER":
                    typeCodeOtp = 9
                    break;
                case "EXTERNAL_TRANSFER":
                    typeCodeOtp = 18
                    break;
                case "OWN_TRANSFER":
                    typeCodeOtp = 34
                    break;
                case "ADD_BENEFICIARY":
                    typeCodeOtp = 14
                    break;
                case "REMOVE_BENEFICIARY":
                    typeCodeOtp = 19
                    break;
                case "UPDATE_BENEFICIARY":
                    typeCodeOtp = 31
                    break;
                default:
                    break;
            }

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: typeCodeOtp,
                inputOtp: values.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()
            const { error, message, type: typeMessage, viewDialogOtp, authorizeTransactions } = responseValidateCode;

            if (error === false) {

                if (process === 'INTERNAL_TRANSFER') {

                    if (sendTransaction === false) {
                        this.setState({ sendTransaction: true })
                        const sendData = encrypt(JSON.stringify({
                            NumeroCuentaOrigen: accountSelected.PRODUCTBANKID,
                            TipoCuentaOrigen: accountSelected.PRODUCTALIAS,
                            NumeroCuentaDestino: number,
                            Valor: amount,
                            Detalle: concept,
                            emailBeneficiario: transfersData.email.toLowerCase(),
                            dataDevice: {
                                ip,
                                mac,
                                device
                            },
                            otp: values.data
                        }))
                        this.props.internalTransferRequest({
                            sendData
                        }).then(res => {
                            //console.log(res)
                            const { error } = res.payload
                            let response = res.payload.data
                            this.setState({ sendTransaction: false })
                            if (error) {
                                this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                this.handleCloseDialogOTP()
                                this.setState({ loading: false })
                            } else {
                                this.handleUpdatedBalances()
                                this.handleCloseDialogOTP()
                                this.setState({ loading: false, isviewvoucher: true, responseservertransfer: response, numberdocumento: response.numeroMensajeTransaccion })
                                this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                //history.push('/')
                            }
                        }).catch(err => {
                            this.setState({ sendTransaction: false })
                            this.setState({ loading: false })
                            this.handleCloseDialogOTP()
                            this.props.handleOpenSnack(err.message, 'error')

                        })
                    }


                } else if (process === 'EXTERNAL_TRANSFER') {

                    if (sendTransaction === false) {
                        this.setState({ sendTransaction: true })

                        const sendData = encrypt(JSON.stringify({
                            trnCode: `701010`,
                            NumeroCuentaOrigen: accountSelected.PRODUCTBANKID,
                            NumeroCuentaDestino: number,
                            subTrnCode:"",
                            cuentaOrigen: accountSelected.PRODUCTBANKID,
                            cuentaDestino: number,
                            accountTypeOrigen: accountSelected.PRODUCTTYPEID,
                            accountTypeDestino: type,
                            destDocumentNumber:`${this.valueofidentification(cedule)}|${cedule}`,
                            Detalle: concept,
                            userDocumentId:`${this.valueofidentification(user)}|${user}`,
                            Valor: amount,
                            isWeb: mac === 'NAVEGADOR' ? true : false,
                            emailBeneficiario: email,
                            nombreBeneficiario: name,
                            Beneficiarioseleccionado: beneficiarySelected,
                            NombreInstitucion: name_institution,
                            DestinationName: name,
                            DestinationBank: name_institution,
                            BankRoutingCode: institution,
                            dataDevice: {
                                ip,
                                mac,
                                device
                            },
                            otp: values.data,
                            type: typeCodeOtp,
                        }))

                        if (authorizeTransactions) {
                          const authorizeTransactionsResp = await feathersCreateData('process-authorize-transaction', {
                            payload: sendData,
                            service: 'REGISTER_TRANSACTION'
                          })()
                          this.setState({ loading: false })
                          this.handleCloseDialogOTP()
                          this.handleCancelTransferForm()
                          this.props.handleOpenSnack(authorizeTransactionsResp.message, authorizeTransactionsResp.type)
                          return
                        }

                        this.props.externalTransferRequest({
                            sendData
                        }).then(res => {
                            // console.log('respuesta del server ', res)
                            this.setState({ sendTransaction: false })
                            const { error } = res.payload
                            let response = res.payload.data
                            if (error) {
                                //console.log('errror de transaccion')
                                this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                this.setState({ sendTransaction: false })
                                this.setState({ loading: false })
                            } else {
                                this.handleUpdatedBalances()
                                this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                this.setState({ loading: false, isviewvoucher: true, responseservertransfer: response, numberdocumento: response.numeroMensajeTransaccion })
                            }

                            this.handleCloseDialogOTP()
                        }).catch(err => {
                            this.setState({ sendTransaction: false })
                            this.setState({ loading: false })
                            this.handleCloseDialogOTP()
                            //console.log('error en transferecnia', err)
                            // this.props.handleOpenSnack('Error al realizar transacción. Por favor intente nuevamente.', 'error')
                        })
                    }

                } else if (process === "ADD_BENEFICIARY") {

                    this.setState({ loading: true })

                    //console.log(beneficiaryDataSend)

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action: "ADD_BENEFICIARY",
                        dataUsersDefault: beneficiaryDataSend,
                        dataDevice: {
                            ip,
                            mac,
                            device,
                        },
                        type: 14,
                        otp: values.data
                    }))
                    // console.log('add 3')
                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

                    if (responseCreateBeneficiary.error === false) {
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({ openBeneficiaryForm: false, loading: false })
                        this.clearForm()
                        this.handleCloseDialogOTP()
                        this.setState({ beneficiarySelected: { ...beneficiaryDataSend, accname: beneficiaryDataSend.type, id: responseCreateBeneficiary.data } })
                    } else {
                        this.setState({ loading: false })
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else if (process === "REMOVE_BENEFICIARY") {

                    this.setState({ loading: true })

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action: "REMOVE_BENEFICIARY",
                        dataUsersDefault: beneficiaryDataSend,
                        dataDevice: {
                            ip,
                            mac,
                            device,
                        },
                        type: 19,
                        otp: values.data
                    }))

                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

                    if (responseCreateBeneficiary.error === false) {
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({ loading: false })
                        this.handleCloseBeneficiaryList()
                        this.handleCloseDialogOTP()
                    } else {
                        this.setState({ loading: false })
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else if (process === "UPDATE_BENEFICIARY") {

                    this.setState({ loading: true })

                    const sendDataAddBeneficiary = encrypt(JSON.stringify({
                        action: "UPDATE_BENEFICIARY",
                        dataUsersDefault: beneficiaryDataSend,
                        dataDevice: {
                            ip,
                            mac,
                            device,
                        },
                        type: 31,
                        otp: values.data
                    }))

                    const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

                    if (responseCreateBeneficiary.error === false) {
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                        this.setState({
                            loading: false, externalBeneficiary: {
                                open: false,
                                data: {}
                            }
                        })
                        this.handleCloseBeneficiaryList()
                        this.handleCloseDialogOTP()
                    } else {
                        this.setState({ loading: false })
                        this.handleCloseDialogOTP()
                        this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
                    }

                } else if (process === 'OWN_TRANSFER') {

                    if (sendTransaction === false) {
                        this.setState({ sendTransaction: true })
                        //let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                        //this.setState({loading:true})
                        //accountSelected.Codigo
                        const sendData = encrypt(JSON.stringify({
                            NumeroCuentaOrigen: accountSelected.codigo,
                            TipoCuentaOrigen: accountSelected.tipoCuentaNombre,
                            NumeroCuentaDestino: number,
                            Valor: amount,
                            Detalle: concept,
                            emailBeneficiario: transfersData.email.toLowerCase(),
                            dataDevice: {
                                ip,
                                mac,
                                device
                            },
                            otp: values.data
                        }))
                        this.props.ownTransferRequest({
                            sendData
                        }).then(res => {
                            //console.log(res)
                            const { error } = res.payload
                            let response = res.payload.data
                            this.setState({ sendTransaction: false })
                            if (error) {
                                this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                this.handleCloseDialogOTP()
                                this.setState({ loading: false })
                            } else {
                                this.handleUpdatedBalances()
                                // console.log('respuesta del server ', res.payload)
                                this.handleCloseDialogOTP()
                                this.setState({ loading: false, isviewvoucher: true, responseservertransfer: response, numberdocumento: response.numeroMensajeTransaccion })
                                //this.handleCancelTransferForm()
                                this.props.handleOpenSnack(res.payload.message, res.payload.type)
                                //history.push('/')
                            }
                        }).catch(err => {
                            this.setState({ sendTransaction: false })
                            this.setState({ loading: false })
                            this.handleCloseDialogOTP()
                            // this.props.handleOpenSnack('Error al realizar transacción. Por favor intente nuevamente.', 'error')
                            this.props.handleOpenSnack(err.message, 'error')

                        })
                    }
                }

            } else {
                if (viewDialogOtp === false) {
                    this.handleCloseDialogOTP()
                } else {
                    this.setState({
                        openDialogOTP: true
                    })
                }
                this.props.handleOpenSnack(message, typeMessage)
                this.setState({ loading: false })
            }

        } catch (error) {
            this.setState({ loading: false })
            this.props.handleOpenSnack('Ha ocurrido un error al realizar la operación.', 'error')
        }

    }

    handleCloseDialogOTP = () => {
        this.setState({ openDialogOTP: false });
    };
    handleCancelTransferForm = () => {
        this.setState({ beneficiarySelected: {} })
        //history.push('/')
    }
    handleOpenBeneficiaryForm = () => {
        this.setState({ openBeneficiaryForm: true, openAccordionInternal: true, openAccordionExternal: true })
    }
    handleonCloseBeneficiaryForm = () => {
        this.setState({
            openBeneficiaryForm: false, beneficiaryFormData: {
                number: '',
                cedule: '',
                name: '',
                email: '',
                entity: '',
                type: '',
                Customers: {},
                accounts: []
            }
        })
    }
    handleGetAccount = (id, field) => {
        const { beneficiaries } = this.props
        //console.log('buscando ....', id, field)
        this.clearForm()
        if (field === 'account') {
            const getBeneficiaryInStore = beneficiaries.find(beneficiary => beneficiary.number === id)
            if (getBeneficiaryInStore === undefined) {
                this.props.getBeneficiaryCoreAccount(id).then(r => {
                    //console.log('encuentra esto ', r.payload)
                    if (r.payload.error) {
                        this.props.handleOpenSnack(r.payload.message, r.payload.type)
                    } else {
                        const { identificacion, nombres, apellidos, razonSocial, secuencialTipoIdentificacion, correoElectronico, cuentaDetallesConsolidado } = r.payload.data
                        const accountsFind = cuentaDetallesConsolidado.filter(acc => acc.tipoCuentaNombre !== 'CERTIFICADOS DE APORTACION')
                        if (accountsFind.length > 0) {
                            //console.log("Cuentas Filtradas ", accountsFind)
                            this.setState({
                                beneficiaryFormData: {
                                    number: id,
                                    name: (secuencialTipoIdentificacion === "CEDULA DE IDENTIDAD") ? nombres + " " + apellidos : razonSocial,
                                    email: correoElectronico,
                                    cedule: identificacion,
                                    accounts: accountsFind
                                }
                            })
                        } else {
                            //console.log("No se ha encontrado el numero de cuenta.")
                            this.props.handleOpenSnack('No se ha encontrado el numero de cuenta.', 'info')
                        }
                    }
                    // this.setState({beneficiaryFormData: r.payload })
                }).catch(error => {
                    //console.log('el error ', error)
                    this.props.handleOpenSnack('La cuenta no existe.', 'error')
                })
            } else {
                this.props.handleOpenSnack('El beneficiario ya se encuentra agregado.', 'info')
                // const { number, name, email, cedule } = getBeneficiaryInStore
                this.handleCloseDialogOTP()
            }
        } else {
            this.props.getBeneficiaryCore({ Identificacion: id, SecuencialEmpresa: 1 }).then(r => {
                //console.log('encuentra esto ', r.payload)
                if (r.payload.data.cuentaDetallesConsolidado.length === 0) {
                    this.props.handleOpenSnack("El usuario no tiene cuentas disponibles.", "info");
                } else {
                    const { identificacion, nombres, apellidos, razonSocial, secuencialTipoIdentificacion, correoElectronico, cuentaDetallesConsolidado } = r.payload.data
                    this.setState({
                        beneficiaryFormData: {
                            number: id,
                            name: (secuencialTipoIdentificacion === "CEDULA DE IDENTIDAD") ? nombres + " " + apellidos : razonSocial,
                            email: correoElectronico,
                            cedule: identificacion,
                            accounts: cuentaDetallesConsolidado
                        }
                    })
                }
                // this.setState({beneficiaryFormData: r.payload })
            }).catch(error => {
                //console.log('el error ', error)
                this.props.handleOpenSnack('El usuario no existe.', 'error')
            })
        }


    }
    handleAccountSelect = (value) => {
        // console.log('cambio ', value)
        this.setState({ accountSelected: value })
    }
    handleChangeEntity = (entity) => {
        try {
            const { institutions, getInstitutionCore } = this.props

            const findInstitutionsInStore = institutions.find(ins => {
                if (ins.codigo === entity.codigo) {
                    return true
                } else {
                    return false
                }
            })
            if (findInstitutionsInStore !== undefined) {
                this.setState({ institutions: findInstitutionsInStore.informacionInstituciones })
            } else {
                getInstitutionCore({ CodigoTipoInstitucion: entity.codigo }).then(res => {
                    /* console.log("Consultando: ", res)
                    // console.log("Codigo: ", entity.Codigo) */
                    const { error, data } = res.payload
                    if (error) {
                        this.props.handleOpenSnack(res.payload.message, res.payload.type)
                    } else {
                        if (entity.codigo === "2") {
                            //console.log("CONSULTA COOPERATIVAS ", entity.Codigo)
                            const filterIntitutions = data.informacionInstituciones.filter(item => item.nombre !== "COOPERATIVA GAÑANSOL");
                            this.setState({ institutions: filterIntitutions })
                        } else {
                            //console.log("CONSULTA OTROS ", entity.Codigo)
                            this.setState({ institutions: data.informacionInstituciones })
                        }
                    }

                })
            }
            this.setState(prevState => ({
                beneficiaryFormDataExternal: {
                    ...prevState.beneficiaryFormDataExternal,
                    entity
                }
            }))
        } catch (error) {
            //console.log(error)
        }

    }
    handleUpdateBeneficiary = async (beneficiary) => {

        try {

            //console.log(beneficiary)

            this.setState({ loading: true })

            const { entities } = this.props

            //console.log(institutions)

            const responseFilterInstitution = entities.institucionTransferencias.filter((row) => row.spi_code.toString() === beneficiary.institution.toString())

            //console.log(responseFilterInstitution)

            /* const { ip, device, mac } = this.props.devices

            let sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE',
                type : 31,
                deviceData: device,
                ip,
                mac
            } ))

            await feathersCreateData('codes-recovery', { sendData })() */

            const { ip, device, mac } = this.props.devices

            const sendDataAddBeneficiary = encrypt(JSON.stringify({
                action: "UPDATE_BENEFICIARY",
                dataUsersDefault: {
                    ...beneficiary,
                    name_institution: (responseFilterInstitution.length > 0) ? responseFilterInstitution[0].institution_name : "COOPERATIVA GAÑANSOL"
                },
                dataDevice: {
                    ip,
                    mac,
                    device,
                },
                type: 31,
                otp: ""
            }))

            const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

            if (responseCreateBeneficiary.error === false) {
                this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                this.setState({
                    loading: false, externalBeneficiary: {
                        open: false,
                        data: {}
                    }
                })
                this.handleCloseBeneficiaryList()
                //this.handleCloseDialogOTP()
            } else {
                this.setState({ loading: false })
                //this.handleCloseDialogOTP()
                this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
            }

        } catch (error) {

            this.props.handleOpenSnack('Ha ocurrido un error al actualizar el beneficiario.', 'error')
            this.setState({ loading: true })

        }

    }
    // renders
    renderBeneficiaryForm = () => {
        const { entities } = this.props
        const { institutions } = this.state
        return <BeneficiaryFormDialog
            {...this.state}
            //beneficiaries = {this.state.beneficiaries}
            //handleOpenSnack = {this.props.handleOpenSnack}
            clearForm={this.clearForm}
            findAccountUser={this.handleGetAccount}
            accounts={this.state.beneficiaryFormData.accounts}
            institutions={institutions}
            entities={entities}
            // email = {"asda@asd.com"}
            setEntity={this.handleChangeEntity}
            setInstitution={
                institution => this.setState({
                    ...this.state,
                    beneficiaryFormDataExternal: {
                        ...this.state.beneficiaryFormDataExternal,
                        institution
                    }
                })
            }
            setDocument={
                document => this.setState(prevState => ({
                    beneficiaryFormDataExternal: {
                        ...prevState.beneficiaryFormDataExternal,
                        document
                    }
                }))
            }
            setType={type => this.setState({
                ...this.state,
                beneficiaryFormDataExternal: {
                    ...this.state.beneficiaryFormDataExternal,
                    type
                }
            })}
            onAcceptClick={this.onAcceptClick}
            AddBeneficiaryCore={this.handleAddBeneficiaryCore}
            getSelectAccount={this.handleGetSelectAccount}
            onCloseBeneficiaryForm={this.handleonCloseBeneficiaryForm}
            handleChangeOpenAccordionInternal={this.handleChangeOpenAccordionInternal}
            handleChangeOpenAccordionExternal={this.handleChangeOpenAccordionExternal}
            typeBeneficiaries={this.props.typeBeneficiaries}
        />
    }
    renderTransferForm = () => {
        const { loading, beneficiarySelected } = this.state
        // console.log('beneficiario seleccionado ', beneficiarySelected)
        if (loading) {
            return <CircularProgress />
        } else {
            return <TransferForm
                amount={""}
                email={beneficiarySelected.email}
                onSubmit={this.handleSubmit}
                dataForm={{}}
                cancelButton={this.handleCancelTransferForm} />
        }
    }
    renderBeneficiaryList = () => {
        return <BeneficiaryList
            {...this.state}
            openDialogBeneficiaryForm={() => {
                this.handleCloseBeneficiaryList()
                this.handleOpenBeneficiaryForm()
            }
            }
            getBeneficiarySelected={this.handleGetBeneficiarySelected}
            onCloseDialogBeneficiaryList={this.handleCloseBeneficiaryList}
            handleChangeOpenAccordionInternal={this.handleChangeOpenAccordionInternal}
            handleChangeOpenAccordionExternal={this.handleChangeOpenAccordionExternal}
            editBeneficiary={(select) => {
                // console.log(select)
                const { beneficiary } = select
                // console.log(beneficiary)
                if (beneficiary === 'INTERNO')
                    this.setState({ internalBeneficiary: { ...this.state.internalBeneficiary, open: true, data: select } })
                else {
                    //this.handleChangeEntity({codigo: select.entity})
                    if (beneficiary === 'EXTERNO') {
                        this.setState({ externalBeneficiary: { ...this.state.externalBeneficiary, open: true, data: select } })
                    } else {
                        this.setState({ ownBeneficiary: { ...this.state.externalBeneficiary, open: true, data: select } })
                    }
                }
            }
            }
            deleteBeneficiary={async (select) => {
                //console.log(select)
                //const { beneficiary } = select
                //if (beneficiary === 'INTERNO') {

                try {

                    this.setState({
                        openDialogConfirmation: true,
                        beneficiaryDataSend: select,
                        process: "REMOVE_BENEFICIARY"
                    })

                } catch (error) {

                    this.props.handleOpenSnack('Ha ocurrido un error al generar el otp.', 'error')
                    this.setState({ loading: true })
                }
                //}
            }
            }
            handleConvertMask={this.handleConvertMask}
            typeBeneficiaries={this.props.typeBeneficiaries}
        />
    }
    renderDialogConfirm = () => {
        const { internalBeneficiary, confirmDialog } = this.state
        return <StandardDialog
            open={confirmDialog.open}
            title={confirmDialog.title}
            handleClose={() => this.setState({ confirmDialog: { open: false, title: '' } })}
        >
            <DialogContentText id="alert-dialog-description">
                {<b>{`¿Desea eliminar el beneficiario ${internalBeneficiary.data.name} ?`}</b>}
            </DialogContentText>
            <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => this.handleAceptDialog(internalBeneficiary)}
                    >
                        Eliminar
                    </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" onClick={() => this.setState({ confirmDialog: { open: false, title: '' } })}>Cancelar</Button>
                </Grid>
            </Grid>
        </StandardDialog>
    }


    handleSendEmailWithVoucher = () => {

        this.setState({ loading: true })

        const { email } = this.props.auth;

        // console.log("Correo Electronico: ", CorreoElectronico);

        const { nombreArchivoComprobante } = this.state.responseservertransfer;

        //const { Monto, NumeroCuentaOrigen } = responseservertransfer;

        let object_send_email_with_voucher = {
            Documento: nombreArchivoComprobante,
            Email: email
        }

        this.props.sendEmailWithVoucher(object_send_email_with_voucher).then(
            response => {

                const { message, type } = response.payload;

                this.setState({ loading: false })

                this.props.handleOpenSnack(message, type);
            }
        ).catch(
            error => {
                // console.log(error);
                this.setState({ loading: false })
                this.props.handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
            }
        )
    }

    handleDownloadVoucher = () => {
        const { responseservertransfer } = this.state;
        window.open(urlVoucher + responseservertransfer.nombreArchivoComprobante + ".pdf", '_blank');
    }

    resetviewtransfert = () => {
        this.setState({
            isviewvoucher: false,
            beneficiarySelected: {}
        })
    }

    onKeyPress = (ev) => {
        //console.log(ev.target.value)
        const tokenLengthObj = filterArrayEqual(this.props.parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6
        if (ev.key === 'Enter') {
            ev.preventDefault()
        } else {
            if (ev.target.value.toString().length === tokenLength) {
                // console.log("VALUE OTP: ", valueinput)
                this.handleOTPSubmit({ data: ev.target.value });
            }

        }
    }

    handleConvertMask = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }

    }

    refreshToken = async () => {
        //this.handleSubmit
        const { devices } = this.props
        const { process, beneficiaryDataSend } = this.state;

        switch (process) {
            case "INTERNAL_TRANSFER":
                this.handleProcessTransfer()
                break;
            case "EXTERNAL_TRANSFER":
                this.handleProcessTransfer()
                break;
            case "OWN_TRANSFER":
                this.handleProcessTransfer()
                break;
            case "ADD_BENEFICIARY":
                if (beneficiaryDataSend.beneficiary === "INTERNO") {
                    this.handleAddBeneficiaryCore()
                } else {
                    try {

                        this.setState({
                            loading: true
                        })

                        const { ip, device, mac } = devices

                        let sendData = encrypt(JSON.stringify({
                            emited: 'NAVCREATECODE',
                            type: 14,
                            deviceData: device,
                            ip,
                            mac
                        }))

                        await feathersCreateData('codes-recovery', { sendData })()

                        this.setState({
                            initialTime: Date.now(),
                            openDialogOTP: true,
                            loading: false
                        })

                    } catch (error) {

                        this.setState({
                            loading: false
                        })

                        this.props.handleOpenSnack('Ha ocurrido un error al generar el codigo.', 'error')
                    }
                }

                break;
            case "UPDATE_BENEFICIARY":
                try {

                    this.setState({
                        loading: true
                    })

                    const { ip, device, mac } = devices

                    let sendData = encrypt(JSON.stringify({
                        emited: 'NAVCREATECODE',
                        type: 31,
                        deviceData: device,
                        ip,
                        mac
                    }))

                    await feathersCreateData('codes-recovery', { sendData })()

                    this.setState({
                        initialTime: Date.now(),
                        openDialogOTP: true,
                        loading: false
                    })

                } catch (error) {

                    this.setState({
                        loading: false
                    })

                    this.props.handleOpenSnack('Ha ocurrido un error al generar el codigo.', 'error')
                }
                break;
            default:
                break;
        }


    }
    renderOTPRequest = () => {
        const timeLifeTokenObj = filterArrayEqual(this.props.parameters, 'code', 'TIME_LIFE_TOKEN')
        const timeLifeToken = parseInt(timeLifeTokenObj[0].value)
        return <DialogOTP
            {...this.state}
            showQR={false}
            onCloseDialogOTP={this.handleCloseDialogOTP}
            onKeyPress={this.onKeyPress}
            handleChangeInputOtp={this.handleChangeInputOtp}
            OTPSubmit={this.handleOTPSubmit}
            refreshToken={this.refreshToken}
            timeLifeToken={timeLifeToken}
        />
    }

    renderBody = () => {
        // console.log('THIS.STATE: ', this.state)
        const { entities } = this.props
        const { accounts, accountSelected, beneficiarySelected, institutions, isviewvoucher, responseservertransfer } = this.state
        const { numeroCuentaOrigen, tipoCuentaOrigen, nombreBeneficiario, monto, numeroCuentaDestino, tipoCuentaDestino, institucion, comision, concepto, fecha, numeroMensajeTransaccion, nombreArchivoComprobante, dispositivo } = responseservertransfer;
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para realizar transferencias'} />
            } else {
                return <Paper elevation={0} style={{
                    padding: "20px",
                    // border: '2px solid #BEBCC0',

                    borderRadius: "8px",
                    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
                }}>
                    {
                        (accounts.length > 0) &&
                        <UserPanelInfoMobile
                            tittle={"TRANSFERENCIAS A OTRAS INSTITUCIONES"}
                            user={this.props.user}
                            balances={this.props.balances}
                            accountSelected={accountSelected}
                            changeAccount={this.handleAccountSelect}
                            handleAccountChange={this.handleAccountChange}
                            dialog={this.state.opendialoglistaccount}
                        >
                            {
                                (isviewvoucher === true) ?
                                    <VoucherTransfersWeb
                                        title={"TRANSFERENCIA EXITOSA"}
                                        titleone={"DATOS EMISOR"}
                                        databodyone={[
                                            {
                                                title: "Nombres",
                                                value: this.props.user.Name,
                                                order: 1
                                            },
                                            {
                                                title: "Cuenta",
                                                value: this.handleConvertMask(numeroCuentaOrigen),
                                                order: 2
                                            },
                                            {
                                                title: "Fecha",
                                                value: moment(fecha).format("YYYY-MM-DD"),
                                                order: 3
                                            },
                                            {
                                                title: "Concepto",
                                                value: concepto,
                                                order: 4
                                            },
                                            {
                                                title: "Dcto. de trans",
                                                value: numeroMensajeTransaccion,
                                                order: 5
                                            }
                                        ]}
                                        titletwo={"DATOS BENEFICIARIO"}
                                        databodytwo={[
                                            {
                                                title: "Nombres",
                                                value: nombreBeneficiario,
                                                order: 1
                                            },
                                            {
                                                title: "Cuenta",
                                                value: this.handleConvertMask(numeroCuentaDestino),
                                                order: 2
                                            },
                                            {
                                                title: "Institución",
                                                value: institucion,
                                                order: 3
                                            },
                                        ]}
                                        nombreCliente={(this.props.user.esPersonaNatural === false) ? this.props.user.razonSocial : this.props.user.nombres + " " + this.props.user.apellidos}
                                        numeroCuentaOrigen={this.handleConvertMask(numeroCuentaOrigen)}
                                        tipoCuentaOrigen={tipoCuentaOrigen}
                                        nombreBeneficiario={nombreBeneficiario}
                                        numeroCuentaDestino={this.handleConvertMask(numeroCuentaDestino)}
                                        tipoCuentaDestino={tipoCuentaDestino}
                                        institucion={institucion}
                                        monto={monto}
                                        comision={comision}
                                        concepto={concepto}
                                        fecha={fecha}
                                        dispositivo={dispositivo}
                                        typesizegrid={6}
                                        resetviewtransfert={this.resetviewtransfert}

                                        handleDownloadVoucher={this.handleDownloadVoucher}
                                        handleDownloadDevice={() => {
                                            try {
                                                const namefile = nombreArchivoComprobante
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher + namefile + ".pdf",
                                                    nameFile: namefile,
                                                    extension: 'pdf',
                                                    messageSend: 'Transferencia'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            } catch (error) {
                                                //console.log(error)

                                            }
                                        }}
                                    />

                                    :
                                    beneficiarySelected.user ?
                                        <div>
                                            <List style={{ flexGrow: 1 }}>
                                                <ListItem button  >
                                                    <ListItemAvatar>
                                                        <Avatar aria-label="recipe" style={{ backgroundColor: '#2E2757' }} >
                                                            <AccountCircleIcon />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            <span style={{ color: 'rgb(0, 0, 1)', fontWeight: 'bold', fontSize: '0.79rem' }}>
                                                                {`${beneficiarySelected.name} `}
                                                            </span>
                                                        }
                                                        secondary={
                                                            <span style={{ color: 'rgb(0, 0, 1)', fontSize: '0.875rem' }}>
                                                                {`${beneficiarySelected.accname} - ${this.handleConvertMask(beneficiarySelected.number)}`}
                                                            </span>
                                                        } />
                                                </ListItem>
                                            </List>
                                            {
                                                this.renderTransferForm()
                                            }
                                        </div>
                                        :

                                        <List style={{ flexGrow: 1 }}>
                                            <ListItem button onClick={() => this.handleOpenBeneficiaryList()}>
                                                <ListItemAvatar>
                                                    <Avatar aria-label="recipe" style={{ backgroundColor: '#2E2757' }}>
                                                        <AccountCircleIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={(this.props.typeBeneficiaries !== "PROPIA") ? "Seleccione Beneficiario" : "Seleccionar una Cuenta"} secondary="" />
                                            </ListItem>
                                            {(this.props.typeBeneficiaries !== "PROPIA" && this.state.permissions.includes(3)) && <ListItem button onClick={() => this.handleOpenBeneficiaryForm()}>
                                                <ListItemAvatar>
                                                    <Avatar aria-label="recipe" style={{ backgroundColor: '#2E2757' }}>
                                                        <AddIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={"Agregar Nuevo Beneficiario"} secondary="" />
                                            </ListItem>}
                                        </List>
                            }
                            {this.renderBeneficiaryList()}
                            {this.renderBeneficiaryForm()}
                            {this.renderOTPRequest()}
                            <BeneficiaryInternalForm
                                internalBeneficiary={this.state.internalBeneficiary}
                                onCloseBeneficiaryForm={() => this.setState({
                                    internalBeneficiary: {
                                        ...this.state.internalBeneficiary,
                                        open: false
                                    }
                                })}
                                onAcceptClick={(data) => { this.handleUpdateBeneficiary(data) }}
                            />
                            <BeneficiaryOwnFormEdit
                                ownBeneficiary={this.state.ownBeneficiary}
                                onCloseBeneficiaryForm={() => this.setState({
                                    ownBeneficiary: {
                                        ...this.state.ownBeneficiary,
                                        open: false
                                    }
                                })}
                                onAcceptClick={(data) => { this.handleUpdateBeneficiary(data) }}
                            />
                            <BeneficiaryExternalForm
                                externalBeneficiary={this.state.externalBeneficiary}
                                beneficiaries={this.state.beneficiaries}
                                handleOpenSnack={this.props.handleOpenSnack}
                                onCloseBeneficiaryForm={() => {
                                    //console.log('cierra ventana')
                                    this.setState({ beneficiarySelected: {} })
                                    this.setState({
                                        externalBeneficiary: {
                                            ...this.state.externalBeneficiary,
                                            open: false

                                        }
                                    })
                                }
                                }
                                institutions={institutions}
                                changeEntity={(Codigo) => this.handleChangeEntity({ codigo: Codigo })}
                                setDocument={(document) => {
                                    //console.log("Nuevo tipo de documento ",document)
                                    let newobject = {
                                        data: { ...this.state.externalBeneficiary.data, document },
                                        open: true
                                    }
                                    //console.log("Nuevo tipo de documento ",newobject)
                                    this.setState({
                                        externalBeneficiary: newobject
                                    })
                                }}
                                document={this.state.externalBeneficiary.data.document}
                                entities={entities}
                                onAcceptClick={this.handleUpdateBeneficiary}
                                onDeleteClick={(internalBeneficiary) => {
                                    this.setState({ internalBeneficiary: { ...this.state.internalBeneficiary, data: internalBeneficiary } })
                                    this.setState({ confirmDialog: { open: true, title: 'Eliminar Beneficiario' } })
                                }}


                            />

                            {this.renderDialogConfirm()}

                        </UserPanelInfoMobile>
                    }
                </Paper>
            }


        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para realizar transferencias'} />
            } else {
                return <div>
                    <Paper elevation={0} style={{
                        padding: "20px",
                        // border: '2px solid #BEBCC0',

                        borderRadius: "16px",
                        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
                    }}>
                        {
                            (accounts.length > 0) &&
                            <Transfers
                                {...this.state}
                                tittle={(this.props.typeBeneficiaries === "INTERNO") ? "TRANSFERENCIAS A TERCEROS - MISMA INSTITUCIÓN" : (this.props.typeBeneficiaries === "EXTERNO") ? "TRANSFERENCIAS OTRAS INSTITUCIONES" : "TRANSFERENCIAS CUENTAS PROPIAS - MISMA INSTITUCIÓN"}
                                user={this.props.user}
                                balances={this.props.balances}
                                openBeneficiaryList={this.handleOpenBeneficiaryList}
                                openDialogBeneficiaryForm={this.handleOpenBeneficiaryForm}
                                transferForm={this.renderTransferForm()}
                                dialogOTP={this.renderOTPRequest()}
                                changeAccount={this.handleAccountSelect}
                                accountSelected={accountSelected}
                                handleSendEmailWithVoucher={this.handleSendEmailWithVoucher}
                                handleCancelTransferForm={this.handleCancelTransferForm}
                                resetviewtransfert={this.resetviewtransfert}
                                handleDownloadVoucher={this.handleDownloadVoucher}
                                handleDownloadDevice={() => {
                                    try {

                                        const namefile = nombreArchivoComprobante
                                        let send = {
                                            type: 'action',
                                            action: 'export_voucher',
                                            data: urlVoucher + namefile + ".pdf",
                                            nameFile: namefile,
                                            extension: 'pdf',
                                            messageSend: 'Transferencia'
                                        }
                                        sendMobile(JSON.stringify(send))
                                    } catch (error) {
                                        //console.log(error)

                                    }
                                }}
                                handleConvertMask={this.handleConvertMask}
                                typeBeneficiaries={this.props.typeBeneficiaries}
                            />
                        }
                        {this.renderBeneficiaryList()}
                        {this.renderBeneficiaryForm()}
                        <BeneficiaryInternalForm
                            internalBeneficiary={this.state.internalBeneficiary}
                            onCloseBeneficiaryForm={() => this.setState({
                                internalBeneficiary: {
                                    ...this.state.internalBeneficiary,
                                    open: false
                                }
                            })}
                            onAcceptClick={(data) => { this.handleUpdateBeneficiary(data) }}
                        />
                        <BeneficiaryOwnFormEdit
                            ownBeneficiary={this.state.ownBeneficiary}
                            onCloseBeneficiaryForm={() => this.setState({
                                ownBeneficiary: {
                                    ...this.state.ownBeneficiary,
                                    open: false
                                }
                            })}
                            onAcceptClick={(data) => { this.handleUpdateBeneficiary(data) }}
                        />
                        <BeneficiaryExternalForm
                            externalBeneficiary={this.state.externalBeneficiary}
                            beneficiaries={this.state.beneficiaries}
                            handleOpenSnack={this.props.handleOpenSnack}
                            onCloseBeneficiaryForm={() => {
                                //console.log('cierra ventana')
                                this.setState({ beneficiarySelected: {} })
                                this.setState({
                                    externalBeneficiary: {
                                        ...this.state.externalBeneficiary,
                                        open: false

                                    }
                                })
                            }
                            }
                            setDocument={(document) => {
                                //console.log("Nuevo tipo de documento ",document)
                                let newobject = {
                                    data: { ...this.state.externalBeneficiary.data, document },
                                    open: true
                                }
                                //console.log("Nuevo tipo de documento ",newobject)
                                this.setState({
                                    externalBeneficiary: newobject
                                })
                            }}
                            document={this.state.externalBeneficiary.data.document}
                            entities={entities}
                            institutions={institutions}
                            changeEntity={(Codigo) => this.handleChangeEntity({ codigo: Codigo })}
                            onAcceptClick={this.handleUpdateBeneficiary}
                            onDeleteClick={(internalBeneficiary) => {
                                this.setState({ internalBeneficiary: { ...this.state.internalBeneficiary, data: internalBeneficiary } })
                                this.setState({ confirmDialog: { open: true, title: 'Eliminar Beneficiario' } })
                            }}

                        />
                        {this.renderDialogConfirm()}
                    </Paper>
                    <br></br>
                    <Footer />
                </div >
            }

        }

    }

    handleCloseDialogConfirmationDeleteBeneficiary = () => {
        this.setState({
            openDialogConfirmation: false
        })
    }

    handleDeleteBeneficiary = async () => {

        try {

            this.setState({ loading: true })

            this.handleCloseDialogConfirmationDeleteBeneficiary()

            const { devices } = this.props

            const { beneficiaryDataSend } = this.state
            //console.log(devices)
            const { ip, mac, device } = devices

            const sendDataAddBeneficiary = encrypt(JSON.stringify({
                action: "REMOVE_BENEFICIARY",
                dataUsersDefault: beneficiaryDataSend,
                dataDevice: {
                    ip,
                    mac,
                    device,
                },
                type: 19,
                otp: ""
            }))

            const responseCreateBeneficiary = await feathersCreateData("procces-users-default", { sendData: sendDataAddBeneficiary })()

            if (responseCreateBeneficiary.error === false) {
                this.props.handleOpenSnack(responseCreateBeneficiary.message, 'success')
                this.setState({ loading: false })
                this.handleCloseBeneficiaryList()
                //this.handleCloseDialogOTP()
            } else {
                this.setState({ loading: false })
                //this.handleCloseDialogOTP()
                this.props.handleOpenSnack(responseCreateBeneficiary.message, 'error')
            }

        } catch (error) {
            //console.log(error)
            this.setState({ loading: false })
            this.props.handleOpenSnack("Ha ocurrido un error al eliminar el beneficiario.", 'error')

        }

    }

    render() {

        const { loading } = this.state
        return (
            <div>
                <Dashboard
                    title=""
                    body={this.renderBody()}
                    multiple={false}
                />
                <LoadingScreen open={loading} />
                <DialogConfirm
                    open={this.state.openDialogConfirmation}
                    title="Confirmación"
                    description="¿Está seguro que desea eliminar este beneficiario?"
                    onCloseDialog={this.handleCloseDialogConfirmationDeleteBeneficiary}
                    onAceptDialog={this.handleDeleteBeneficiary}
                />
            </div>
        );
    }
}

TransfersExternalContainer.propTypes = {
    user: PropTypes.object,
    entities: PropTypes.object.isRequired,
};

export default withRouter(connect(null, {
    addBeneficiary,
    getBeneficiaries,
    transferRequest,
    getBeneficiaryCore,
    createCodeRecovery,
    getBeneficiaryCoreAccount,
    internalTransferRequest,
    ownTransferRequest,
    externalTransferRequest,
    codeActivity,
    getBalanceUser,
    getInstitutionCore,
    deleteBeneficiary,
    updateBeneficiary,
    sendEmailWithVoucher,
    changeStatusUser
})(TransfersExternalContainer))
